import { render } from "./RadioSelector.vue?vue&type=template&id=4b7420f4&scoped=true"
import script from "./RadioSelector.vue?vue&type=script&lang=js"
export * from "./RadioSelector.vue?vue&type=script&lang=js"

import "./RadioSelector.vue?vue&type=style&index=0&id=4b7420f4&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7420f4"]])

export default __exports__